var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVrd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_573_4149)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.993 33.0352H19.7581V34.2701V45.3843H3.20807C2.39763 45.3843 1.80688 44.6169 2.01427 43.8334L11.821 6.78591L10.6272 6.4699L11.821 6.78591C11.9643 6.24424 12.4544 5.867 13.0148 5.867H19.7581V14.5114V15.7463H20.993H25.9326H27.1676V14.5114V5.867H33.964C34.5118 5.867 34.9941 6.2279 35.1487 6.75346L46.045 43.801C46.2776 44.5919 45.6847 45.3843 44.8603 45.3843H27.1676V34.2701V33.0352H25.9326H20.993Z",
    fill: "#A3AED0",
    stroke: "#A3AED0",
    strokeWidth: 2.46983
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9929 18.2161H19.758V19.451V29.3304V30.5653H20.9929H25.9326H27.1675V29.3304V19.451V18.2161H25.9326H20.9929Z",
    fill: "white",
    stroke: "#A3AED0",
    strokeWidth: 2.46983
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_573_4149"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(-0.000610352 0.63324)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVrd);
export default __webpack_public_path__ + "static/media/VRD.268ae90675f642869d0ab7a8c495a06d.svg";
export { ForwardRef as ReactComponent };